import { appRoute } from "routes/app/home.runtime"
import { ActionsPage } from "routes/actions/actions-page"
import { HomePageTile } from "slot-definitions"
import { ActionsTile } from "routes/actions/actions-tile"
import NavItem from "minimals-template/components/nav-section/vertical/NavItem"
import { registerPageNavigationWithContent } from "lib/routes/register-page-navigation-with-content"
import { getDisplayActions } from "routes/actions/controller/get-display-actions"
import { hasPermission } from "library/authorization/index.mjs"
import { NavBadge } from "routes/@layouts/app/navbar/nav-badge"

appRoute.register("actions", <ActionsPage $lazy />)

registerPageNavigationWithContent(<NavigateActions />, "/app/actions", "Actions", "mdi:lightning-bolt-circle", {
    subPaths: true,
    predicate: hasPermission("schedules"),
})

export function NavigateActions({ data, depth, active, isCollapse, onClick }) {
    const actions = getDisplayActions.useResults({ type: "all", take: 1 })
    if (!actions) return null
    if (actions.overdue) {
        data.info = <NavBadge count={actions.overdue} label="actions overdue" color="error.main" />
    } else {
        data.info = <NavBadge count={actions.all} label="actions" />
    }

    return (
        <NavItem
            className="nav-item actions"
            item={data}
            depth={depth}
            active={active}
            isCollapse={isCollapse}
            onClick={onClick}
        />
    )
}

HomePageTile.plug(<ActionsTile $lazy priority={105} />)
